<div class="n-organisation-list-page">
  <div class="n-list-component-header">
    <h2>List of organisations</h2>
    <div>
      <!-- <button matIconButton matTooltip="Here comes the info"><mat-icon>info</mat-icon></button> -->
      <button matIconButton matTooltip="Select columns"
        (click)="openColumnSelector()"><mat-icon>view_column</mat-icon></button>
    </div>
  </div>

  <form [formGroup]="filterForm" class="n-filters-form">
    <div>
      <mat-expansion-panel [(expanded)]="filtersExpanded" #filtersPanel style="margin: 5px 0px; flex-grow: 1; ">
        <mat-expansion-panel-header>
          <mat-panel-title><mat-icon>search</mat-icon> Filters </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="n-filter-form-row" style="align-items: flex-start;">
          <div class="n-select-filter-field-column">
            <mat-form-field class="n-search-field n-filter-flex-unit.simple" style="width: 100%">
              <mat-icon matPrefix>search</mat-icon>
              <input matInput placeholder="Name filter" #simpleFilterInput formControlName="textFilter">
            </mat-form-field>
            <app-advanced-select #stakeholderGroupsSelect formControlName="stakeholderGroups"
              [resetTrigger]="resetCounter" class="n-search-field n-filter-flex-unit" label="Stakeholder groups"
              [options]="allStakeholderGroupOptions()" [showAllOrAny]="showAllOrAny()" />
          </div>

          <div class="n-select-filter-field-column">
            <app-advanced-select #projectsSelect formControlName="projects" [resetTrigger]="resetCounter"
              class="n-search-field n-filter-flex-unit" label="Projects" [options]="allProjectOptions()"
              [showAllOrAny]="showAllOrAny()" />
            <app-advanced-select #audiencesSelect formControlName="audiences" [resetTrigger]="resetCounter"
              class="n-search-field n-filter-flex-unit" label="Target audiences" [options]="allAudienceOptions()"
              [showAllOrAny]="showAllOrAny()" />
          </div>

          <div class="n-select-filter-field-column">
            <app-advanced-select #initiativesSelect formControlName="initiatives" [resetTrigger]="resetCounter"
              class="n-search-field n-filter-flex-unit" label="Initiatives" [options]="allInitiativeOptions()"
              [showAllOrAny]="showAllOrAny()" />
            <app-advanced-select #memberTypesSelect formControlName="memberTypes" [resetTrigger]="resetCounter"
              class="n-search-field n-filter-flex-unit" label="Member type" [options]="allMemberTypeOptions"
              [showAllOrAny]="showAllOrAny()" />
          </div>

          <div class="n-select-filter-field-column">
            <app-advanced-select #topicsSelect formControlName="topics" [resetTrigger]="resetCounter"
              class="n-search-field n-filter-flex-unit" label="Topics of interest" [options]="allTopicOptions()"
              [showAllOrAny]="showAllOrAny()" />
            <app-advanced-select #countrySelect formControlName="countries" [resetTrigger]="resetCounter"
              class="n-search-field n-filter-flex-unit" label="Countries" [options]="allCountryOptions()"
              [showAllOrAny]="showAllOrAny()" />
            <!-- <app-country-select #countrySelect formControlName="countries" label="Country"
            class="n-search-field n-filter-flex-unit" [style.width.%]="100" [multiple]="true" /> -->
          </div>

          <button matFab (click)="clearAllFilters()" class="n-filter-reset-button"
            matTooltip="Clear all filters"><mat-icon>clear</mat-icon></button>
        </div>
        <div class="n-lcr-left">
          Show
          <mat-checkbox formControlName="showActiveItems"> active items
          </mat-checkbox>
          <mat-checkbox formControlName="showArchivedItems"> archived items
          </mat-checkbox>
        </div>
      </mat-expansion-panel>
    </div>
  </form>

  <div class="n-table-wrapper">
    @if (loading) {
    <div class="n-spinner-overlay">
      <mat-spinner></mat-spinner>
    </div>
    }

    <div class="n-table-scroll">
      <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">
        <ng-container matColumnDef="valid">
          <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Is data valid?"><mat-icon>check</mat-icon>
          </th>
          <td mat-cell *matCellDef="let organisation">
            @if (organisation.validityStatus() === ValidityStatus.INVALID) {
            <span class="material-symbols-outlined n-invalid-status"
              matTooltip="Record is missing required data">error</span>
            } @else if (organisation.validityStatus() === ValidityStatus.INCOMPLETE) {
            <span class="material-symbols-outlined n-incomplete-status"
              matTooltip="Record is missing important data">warning</span>
            } @else if (organisation.validityStatus() === ValidityStatus.VALID) {
            <span class="material-symbols-outlined n-valid-status" matTooltip="Record is valid">verified</span>
            } @else {
            <span class="material-symbols-outlined">cruelty_free</span>
            }
          </td>
        </ng-container>

        <!-- name Column -->
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
          <td mat-cell *matCellDef="let organisation"><span class="n-ellipsis">{{ organisation.name }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="member">
          <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Member"><span
              class="material-symbols-outlined"
              style="display: inline-block; vertical-align: middle;">family_star</span>
          </th>
          <td mat-cell *matCellDef="let organisation">
            @if (organisation.getActiveMembershipRecords().length > 0) {
            <span class="material-symbols-outlined n-active-membership" matTooltip="Active member"
              style="display: inline-block; vertical-align: middle; ">family_star</span>
            } @else if (organisation.getFutureMembershipRecords().length > 0) {
            <span class="material-symbols-outlined n-future-membership" matTooltip="Future member"
              style="display: inline-block; vertical-align: middle;">family_star</span>
            } @else if (organisation.getPastMembershipRecords().length > 0) {
            <span class="material-symbols-outlined n-past-membership" matTooltip="Past member"
              style="display: inline-block; vertical-align: middle;">family_star</span>
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="supplier">
          <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Supplier"><span
              class="material-symbols-outlined"
              style="display: inline-block; vertical-align: middle;">partner_exchange</span></th>
          <td mat-cell *matCellDef="let organisation">
            @if (organisation.supplierDetails) {
            <span class="material-symbols-outlined"
              style="display: inline-block; vertical-align: middle;">partner_exchange</span>
            }
          </td>
        </ng-container>

        <!-- acronym Column -->
        <ng-container matColumnDef="acronym">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Acronym</th>
          <td mat-cell *matCellDef="let organisation">{{ organisation.acronym }}</td>
        </ng-container>

        <!-- topics Column -->
        <ng-container matColumnDef="topics">
          <th mat-header-cell *matHeaderCellDef>Topics of interest</th>
          <td mat-cell *matCellDef="let organisation">
            <mat-chip-set class="n-my-chip">
              @for (topic of organisation.topics; track topic.id) {
              <mat-chip><span matTooltip="{{topic.name}}">{{ topic.name }}</span></mat-chip>
              }
            </mat-chip-set>
          </td>
        </ng-container>

        <!-- stakeholderGroups Column -->
        <ng-container matColumnDef="stakeholderGroups">
          <th mat-header-cell *matHeaderCellDef>Stakeholder Groups</th>
          <td mat-cell *matCellDef="let organisation">
            <mat-chip-set class="n-my-chip">
              @for (group of organisation.stakeholderGroups; track group.id) {
              <mat-chip><span matTooltip="{{group.name}}">{{ group.name }}</span></mat-chip>
              }
            </mat-chip-set>
          </td>
        </ng-container>

        <!-- projects Column -->
        <ng-container matColumnDef="projects">
          <th mat-header-cell *matHeaderCellDef>Projects</th>
          <td mat-cell *matCellDef="let organisation">
            <mat-chip-set class="n-my-chip">
              @for (project of organisation.projects; track project.id) {
              <mat-chip><span matTooltip="{{project.name}}">{{ project.name }}</span></mat-chip>
              }
            </mat-chip-set>
          </td>
        </ng-container>

        <!-- initiatives Column -->
        <ng-container matColumnDef="initiatives">
          <th mat-header-cell *matHeaderCellDef>Initiatives</th>
          <td mat-cell *matCellDef="let organisation">
            <mat-chip-set class="n-my-chip">
              @for (initiative of organisation.initiatives; track initiative.id) {
              <mat-chip><span matTooltip="{{initiative.name}}">{{ initiative.name }}</span></mat-chip>
              }
            </mat-chip-set>
          </td>
        </ng-container>

        <!-- targetAudiences Column -->
        <ng-container matColumnDef="targetAudiences">
          <th mat-header-cell *matHeaderCellDef>Target audiences</th>
          <td mat-cell *matCellDef="let organisation">
            <mat-chip-set class="n-my-chip">
              @for (audience of organisation.targetAudiences; track audience.id) {
              <mat-chip><span matTooltip="{{audience.name}}">{{ audience.name }}</span></mat-chip>
              }
            </mat-chip-set>
          </td>
        </ng-container>

        <!-- Membership Type Column -->
        <ng-container matColumnDef="membershipType">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Member type</th>
          <td mat-cell *matCellDef="let organisation">
            <mat-chip-set class="n-my-chip">
              @if (getMembershipType(organisation) === 'FULL') {
              <mat-chip><span>Full</span></mat-chip>
              }
              @if (getMembershipType(organisation) === 'ASSOCIATE') {
              <mat-chip><span>Associate</span></mat-chip>
              }
            </mat-chip-set>
          </td>
        </ng-container>

        <!-- countries Column -->
        <ng-container matColumnDef="countries">
          <th mat-header-cell *matHeaderCellDef>Country </th>
          <td mat-cell *matCellDef="let organisation">
            <mat-chip-set class="n-my-chip">
              @for (countryCode of getAllCountries(organisation); track countryCode) {
              <mat-chip [matTooltip]="countryNames().get(countryCode)">
                <span>{{ iso3ToEmojiFlag(countryCode) }}</span>
              </mat-chip>
              }
            </mat-chip-set>
          </td>
        </ng-container>

        <!-- lastModifiedOn Column -->
        <ng-container matColumnDef="lastModifiedOn">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Last modification</th>
          <td mat-cell *matCellDef="let organisation">
            {{ organisation.lastModifiedOn | date:'dd/MM/yyyy HH:mm' }}
          </td>
        </ng-container>


        <tr mat-header-row class="n-grid-header-row" *matHeaderRowDef="selectedColumns"
          [ngStyle]="{ 'grid-template-columns': gridTemplate }">
        </tr>
        <tr mat-row class="n-grid-data-row" [class.n-archived-row]="row.archived"
          *matRowDef="let row; columns: selectedColumns" [ngStyle]="{ 'grid-template-columns': gridTemplate }"
          (click)="goToDetail(row)">
        </tr>

        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" colspan="4">No data matching the filter</td>
        </tr>

      </table>
    </div>
  </div>

  <mat-paginator #paginator class="demo-paginator" showFirstLastButtons="true" hidePageSize="false"
    [pageSizeOptions]="[5,10,25]" aria-label="Select page" />

  <div class="n-lcr-row">
    <div class="n-lcr-left">
      &nbsp;
    </div>
    <div class="n-lcr-center" style="display:flex; gap: 5px; align-items: center; justify-content: center;">
      <button matFab extended class="n-save-button" (click)="add()"><mat-icon>add</mat-icon>Add organisation</button>
      <button matFab extended class="n-export-button" (click)="export()"><mat-icon>file_download</mat-icon>Export
        list</button>
    </div>
    <div class="n-lcr-right"></div>
  </div>
</div>